import * as Dialog from "@radix-ui/react-dialog";
import { useEffect } from "react";
import { ProductEditor } from "./editor";
import { CustomizeModalContent, Overlay, StyledCustomizeModal } from "./styles";
import { genericEventHandler } from "@/analytics/events";
import { GlobalEvents } from "@/analytics/events/constants";
import { CSS_CLASSES } from "@/constants/cssClassNames";
import { useDispatch, useSelector } from "@/redux";
import customizeActions from "@/redux/customize/actions";
import {
  storeFocusedElement,
  restoreFocusedElement,
} from "@/utils/focusReturn";

export const Customizer = () => {
  const { open, product } = useSelector(({ app }) => app.customize);
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      // Store the currently focused element when modal opens
      storeFocusedElement();
      genericEventHandler(GlobalEvents.STORE__PRODUCT_VIEW, {
        name: product?.name,
        details: product?.global_id,
      });
    } else {
      // Restore focus when modal closes
      restoreFocusedElement();
    }
  }, [open, product]);

  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <StyledCustomizeModal
          id="customize"
          className={CSS_CLASSES.PRODUCT_DETAIL.CONTAINER}
        >
          <Overlay />
          <CustomizeModalContent
            role="dialog"
            aria-modal="true"
            aria-labelledby={product?.name ? "product-name" : undefined}
            aria-label={!product?.name ? "Meal details" : undefined}
            onEscapeKeyDown={() => dispatch(customizeActions.clearProduct())}
            onPointerDownOutside={() =>
              dispatch(customizeActions.clearProduct())
            }
          >
            {open && <ProductEditor />}
          </CustomizeModalContent>
        </StyledCustomizeModal>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
